import * as React from 'react';
import { SystemLink } from '../tools/SystemLink'
import { hasReadPermission } from '../../service/userService';

export interface ISystemTileProps {
    width?: number
    height?: number
    key?: string
    x?: number
    y?: number
    link: string,
    icon?: string,
    title: string,
    description: string,
    securityObject: string,
    downloadLink: boolean,
}

export class SystemTile extends React.Component<ISystemTileProps, any, any> {

    state = {
        downloadLink: false,
    }

    componentDidMount() {
        if (this.isValidUrl(this.props.link)) {
            this.setState({ ...this.state, downloadLink: true })
        }
    } 

    isValidUrl = (urlString: any) => {
        var a = document.createElement('a');
        a.href = urlString;
        //return (a.host && a.host != window.location.host);
        return (urlString.indexOf('http://') === 0 || urlString.indexOf('https://') === 0)
    }

    render() {
        var widthClass = "col-xl-3 col-sm-6 mb-3"
        switch (this.props.width) {
            case 1: widthClass = "mb-3 col-md-12"; break;
            case 2: widthClass = "tile-grid col-md-6  mb-3"; break;
            case 3: widthClass = "tile-grid col-md-4  mb-3"; break;
            case 4: widthClass = "tile-grid col-md-3  mb-3"; break;
        }
        return (<>
            {(hasReadPermission(this.props.securityObject) || this.props.securityObject == '') == true ?
                <div className={[widthClass].join(" ")} >
                    <SystemLink to={this.props.link} downloadLink={this.state.downloadLink} className="tiles cardHomeScreen">
                        <div className="tile-icon">
                            <span className={this.props.icon} />
                        </div>
                        <div className="col-md-10 pl-sm-0 pr-sm-0">
                            <h3 className="tile-heading">{this.props.title}</h3>
                            <div className="tile-description">{this.props.description}</div>
                        </div>
                    </SystemLink >
                </div>
                : ''
            }
        </>)
    }
}